<script>
	export let id = null;
	export let label = null;
	export let value = null;
	export let maxlength = null;
	export let required = false;
	export let disabled = false;
	export let placeholder = null;

	let className = $$props.class ? " " + $$props.class : "";
	let style = $$props.style ? $$props.style : null;
</script>

{#if label}
	<label for={id} class:isrequired={required}>{label}</label>
{/if}
<input
	{id}
	class="form-control{className}"
	type="text"
	{required}
	{disabled}
	{placeholder}
	{maxlength}
	bind:value
	on:change
	{style}
/>
